// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OYNH","colBig":"styles_colBig__2cXop","colSmall":"styles_colSmall__2qTru"};